import Vue from "vue";
import App from "./App.vue";
import routes from "./routes.js";

import store from "./store";
import "./registerServiceWorker";
import { SHA512 } from "../public/js/digest";
import VueRouter from "vue-router";
import Vuex from "vuex";
import axios from "axios";

Vue.use(VueRouter);
Vue.use(Vuex);

/* eslint-disable */

// Vue.config.env = "development";
const env = process.env.NODE_ENV;
if (env.toLowerCase() !== "live") {
    Vue.config.devtools = true;
    Vue.config.debug = true;
    Vue.config.useEslint = true;
    Vue.config.productionTip = false;
}

Vue.prototype.$axios = axios;
Vue.prototype.API_CALL_TIMEOUT = 60 * 3 * 1000; //180000, // 3 mins
// Vue.prototype.API_CALL_TIMEOUT = 5000 //180000, // 5 mins
Vue.prototype.baseApiUrl = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.signatureSecret = process.env.VUE_APP_PASS_PHRASE;

Vue.prototype.$amount = (amount) => {
    let amt = amount.toString().split("");
    amt.splice(-2, 0, ".");
    return `₦${amt.join("")}`;
};

Vue.prototype.$formatCard = (str) => {
    const len = str.split("");
    if (len.length == 16) {
        str = str.toUpperCase();
        let prefix = str.slice(0, 4),
            prefix2 = str.slice(4, 8),
            prefix3 = str.slice(8, 12),
            suffix = str.slice(12);
        return `${prefix} ${prefix2} ${prefix3} ${suffix}`;
    } else {
        str = str.toUpperCase();
        let prefix = str.slice(0, 4),
            prefix2 = str.slice(4, 8),
            prefix3 = str.slice(8, 12),
            suffix = str.slice(10);
        return `${prefix} ${prefix2} ${prefix3} ${suffix}`;
    }
};

Vue.prototype.$todaysDate = () => {
    const dt = new Date();
    var AmOrPm = dt.getHours() >= 12 ? "pm" : "am",
        hours = dt.getHours() > 12 ? dt.getHours() : "0" + dt.getHours(),
        minutes = dt.getMinutes() > 9 ? dt.getMinutes() : "0" + dt.getMinutes(),
        year = dt.getFullYear(),
        month = dt.toLocaleString("default", {
            month: "long",
        }),
        day = dt.getDate() > 9 ? dt.getDate() : `0${dt.getDate()} GMT`;

    return `${day} ${month}, ${year} at ${hours}:${minutes}${AmOrPm} GMT`;
};

Vue.prototype.$generateRequestRef = () => {
    return Math.floor(Math.random() * 91232342390).toString(); // 5381571187629017319
};

Vue.prototype.$generateTransactionRef = (length = 0) => {
    return length > 0 ?
        Math.floor(Math.random() * 91232342390)
            .toString()
            .slice(0, length) :
        Math.floor(Math.random() * 91232342390)
            .toString()
            .slice(0, 6);
};

Vue.prototype.$userFriendlyMsisdn = (msisdn) => {
    let clean = "";
    if (msisdn.length == 13 && msisdn.slice(0, 3) == "234") {
        clean = "0" + msisdn.slice(3);
    } else if (msisdn.length == 14) {
        clean = "0" + msisdn.slice(4);
    } else if (msisdn.length == 10 && msisdn.slice(0, -9) != "0") {
        clean = "0" + msisdn;
    }
    return clean;
};

(Vue.prototype.$sortCompare = (a, b) => {
    // Use toUpperCase() to ignore character casing
    const bandA = a.name.toUpperCase();
    const bandB = b.name.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
        comparison = 1;
    } else if (bandA < bandB) {
        comparison = -1;
    }
    return comparison;
}),
    (Vue.prototype.$generateToken = (payload) => {
        let iterationCount = process.env.VUE_APP_ITERATION,
            keySize = process.env.VUE_APP_KEY_SIZE,
            salt = process.env.VUE_APP_SALT,
            passPhrase = process.env.VUE_APP_PASS_PHRASE,
            iv = process.env.VUE_APP_IV,
            plainText = JSON.stringify(payload).trim(),
            aesUtil = new AesUtil(keySize, iterationCount),
            encrypt = aesUtil.encrypt(salt, iv, passPhrase, plainText);
        return encrypt;
    });

Vue.prototype.$decodeToken = (str) => {
    try {
        const iterationCount = process.env.VUE_APP_ITERATION
        const keySize = process.env.VUE_APP_KEY_SIZE
        const salt = process.env.VUE_APP_SALT
        const passPhrase = process.env.VUE_APP_PASS_PHRASE
        const iv = process.env.VUE_APP_IV
        const plainText = str.trim();
        const aesUtil = new AesUtil(keySize, iterationCount);
        const decrypt = JSON.parse(aesUtil.decrypt(salt, iv, passPhrase, plainText));
        return decrypt;
    } catch {
        return {
            status: "Failed",
            retry: true,
            message: "An error occurred while processing this request, please try again later.",
        };
    }
};

/* setTimeout(() => {
    // console.log(JSON.stringify(Vue.prototype.$decodeToken("")));
    // console.log('is email valid', Vue.prototype.$validateEmail('me.com'));
}, 2000) */

Vue.prototype.$maskPhone = (phone) => {
    var prefix = phone.slice(0, -6),
        suffix = phone.slice(9),
        main = `${prefix}*****${suffix}`;
    return main;
};


Vue.prototype.$validateEmail = (str) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(str).toLowerCase());
};

Vue.prototype.$msisdnNGFormat = (msisdn) => {
    let main = "";
    if (msisdn.length == 11) main = "234" + msisdn.slice(1);
    else if (msisdn.length == 13) main = "234" + msisdn.slice(3);
    else if (msisdn.length == 14) main = "234" + msisdn.slice(4);
    else if (msisdn.length == 10 && msisdn.slice(0, -9) != "0")
        main = "234" + msisdn;

    return main;
};

Vue.prototype.formatCard = (str) => {
    str = str.toUpperCase();
    let prefix = str.slice(0, 4),
        prefix2 = str.slice(4, 8),
        prefix3 = str.slice(8, 12),
        suffix = str.slice(10),
        main = `${prefix} ${prefix2} ${prefix3} ${suffix}`;
    return main;
};

(Vue.prototype.$maskEmail = (str) => {
    let splitted = str.split("@"),
        suffix = splitted[1],
        prefix = splitted[0].slice(0, 3),
        main = `${prefix}***@${suffix}`;
    // console.log(main)
    return main;
}),
    (Vue.prototype.$sendInvoiceDateFormate = () => {
        return main;
    }),
    (Vue.prototype.$SHA512 = (str) => {
        return SHA512(str);
    });

const router = new VueRouter({
    routes: routes,
    mode: "history",
});

new Vue({
    render: (h) => h(App),
    router,
    store,
}).$mount("#app");